import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doAnotherRound } from "../../redux/reducers/AnswerReducer2";
import { updateMode } from "../../redux/reducers/ModeReducer";
import ButtonController from "./ButtonController";
import ButtonRepeat from "../../assets/images/others/ButtonRepeat.png";
import ButtonSpeaker from "../../assets/images/others/ButtonSpeaker.png";
import ButtonHome from "../../assets/images/others/ButtonHome.png";
import ButtonPlay from "../../assets/images/others/ButtonPlay.png";
import s from "./style.module.css";

import useSound from "use-sound";

const containerStyle = (top, bottom, width, height) => ({
  position: "absolute",
  top: top,
  left: 0,
  right: 0,
  bottom: bottom,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  width: width,
  height: height,
});
const ContentContainer = ({
  audioTutorial,
  videoLink,
  audioLink,
  LoginType,
  typeHeader,
  textHeader,
  leaderBoard,
  textHeaderColor,
  disableNext,
  disableBack,
  onPressNext,
  onPressBack,
  onCenter,
  onLesson,
  onsubmit,
  contentID,
  ...props
}) => {
  const dispatch = useDispatch();
  // const [play] = useSound(DBLPOP);
  const allScoreRedux = useSelector((state) => state.allScore);
  const [playAudio, setPlayAudio] = useState(true);
  const [audioFile, setAudioFile] = useState(null);
  const [play, { stop, pause }] = useSound(audioLink, {
    // onend: () => {
    //   setPlayAudio(true);
    // },
    // onload: () => {},
  });

  const topSpace = onCenter ? 0 : undefined;
  const bottomSpace = onCenter ? 0 : "4%";
  const widthContent = onLesson ? "90%" : "80%";
  const heightContent = onLesson ? "75%" : "70%";
  const handleAudio = () => {
    setPlayAudio(!playAudio);
    playAudio ? play() : pause();
  };

  useEffect(() => {
    setAudioFile(audioFile);
  }, [playAudio]);

  useEffect(() => {
    setPlayAudio(true);
    stop();
  }, [contentID]);

  return (
    <div
      style={containerStyle(topSpace, bottomSpace, widthContent, heightContent)}
      className={s.contentContainer}
    >
      {!!typeHeader && (
        <div className={typeHeader === 1 ? s.Headersection1 : s.Headersection2}>
          <p style={{ color: textHeaderColor }}>{textHeader}</p>
        </div>
      )}
      <div
        style={{
          width: "95%",
          height: "10%",
          display: "flex",
          justifyContent: "flex-end",
          // backgroundColor: "orange",
        }}
      >
        {audioLink && (
          <img
            onClick={() => handleAudio()}
            className={s.ButtonSpeaker}
            src={ButtonSpeaker}
            alt="ButtonSpeaker"
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "80%",
        }}
      >
        <div className={s.contentWrapper}>{props.children}</div>
      </div>

      {!!leaderBoard ? (
        <div>
          {Math.round(allScoreRedux.userScore) < 70 ? (
            <img
              style={{ marginRight: "3vw" }}
              className={s.ButtonMenu}
              onClick={() => {
                dispatch(updateMode({ mode: 2, step: 1 }));
                dispatch(doAnotherRound());
              }}
              src={ButtonRepeat}
              alt="btnHome"
            />
          ) : (
            <img
              className={s.ButtonMenu}
              onClick={() => {
                onPressNext();
                dispatch(doAnotherRound());
              }}
              src={ButtonHome}
              alt="btnHome"
            />
          )}
        </div>
      ) : null}

      {!!LoginType ? (
        <div>
          <img
            className={s.ButtonMenu}
            onClick={() => {
              dispatch(updateMode({ mode: 2, step: 1 }));
              dispatch(doAnotherRound());
              onsubmit();
            }}
            src={ButtonPlay}
            alt="btnHome"
          />
        </div>
      ) : null}

      <ButtonController
        contentID={contentID}
        videoLink={videoLink}
        disableBack={disableBack}
        disableNext={disableNext}
        onPressNext={onPressNext}
        onPressBack={onPressBack}
      />
    </div>
  );
};

export default ContentContainer;
